export default {"src":"https://dev-static.skin-seoul.com/_next/static/media/chatbot.5d6adb2c.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};